"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classnames = _interopRequireDefault(require("classnames"));

var _CallTopbarWrapperAsync = _interopRequireDefault(require("crm_ui/calling/CallTopbarWrapperAsync"));

var _SubjectDependency = _interopRequireDefault(require("crm_ui/flux/dependencies/SubjectDependency"));

var _CallProviderDependency = _interopRequireDefault(require("crm_ui/calling/dependencies/CallProviderDependency"));

var _LinkedInNavigatorStore = _interopRequireDefault(require("crm_data/linkedin/LinkedInNavigatorStore"));

var _PortalSettingsKeys = require("crm_data/constants/PortalSettingsKeys");

var LoadingStatus = _interopRequireWildcard(require("crm_data/flux/LoadingStatus"));

var _SettingsStore = _interopRequireDefault(require("crm_data/settings/SettingsStore"));

var _links = _interopRequireDefault(require("crm_internal/config/links"));

var _CurrentOwnerContainer = _interopRequireDefault(require("crm_internal/containers/CurrentOwnerContainer"));

var _CurrentTeamsContainer = _interopRequireDefault(require("crm_internal/containers/CurrentTeamsContainer"));

var _RouterContainer = _interopRequireDefault(require("crm_internal/containers/RouterContainer"));

var _CallCommunicatorWrapperAsync = _interopRequireDefault(require("crm_ui/components/profile/iFramedInteractions/CallCommunicatorWrapperAsync"));

var _CommunicatorConstants = require("crm_ui/components/profile/interactions/common/CommunicatorConstants");

var _InteractionValidators = require("crm_ui/components/profile/interactions/common/InteractionValidators");

var _ProfileCommunicatorContainer = _interopRequireDefault(require("crm_ui/components/profile/interactions/ProfileCommunicatorContainer"));

var _ProfileThreeColumn = _interopRequireDefault(require("crm_ui/profile/common/components/ProfileThreeColumn"));

var _QueueTopbarContainerAsync = _interopRequireDefault(require("crm_ui/queues/topbar/QueueTopbarContainerAsync"));

var _SidebarLayoutCompany = _interopRequireDefault(require("crm_ui/sidebar/layouts/SidebarLayoutCompany"));

var _SidebarLayoutContact = _interopRequireDefault(require("crm_ui/sidebar/layouts/SidebarLayoutContact"));

var _SidebarLayoutDeal = _interopRequireDefault(require("crm_ui/sidebar/layouts/SidebarLayoutDeal"));

var _SidebarLayoutTicket = _interopRequireDefault(require("crm_ui/sidebar/layouts/SidebarLayoutTicket"));

var _ProfileTimelineTabsContainer = _interopRequireDefault(require("crm_ui/timeline/components/config/ProfileTimelineTabsContainer"));

var _SampleContactUtils = require("crm_ui/utils/SampleContactUtils");

var _SampleTimelineEventUtils = _interopRequireDefault(require("crm_ui/utils/SampleTimelineEventUtils"));

var _SubjectPermissions = require("crm_ui/utils/SubjectPermissions");

var _PlaybooksActions = require("crm_data/playbooks/actions/PlaybooksActions");

var _CommunicatorActions = require("customer-data-communicator/data/communicator/actions/CommunicatorActions");

var _CommunicatorStore = _interopRequireDefault(require("customer-data-communicator/data/communicator/stores/CommunicatorStore"));

var _ProfileObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ProfileObjectTypesType"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _ImmutableModel = require("customer-data-objects/model/ImmutableModel");

var _loggers = require("customer-data-tracking/loggers");

var _hubspotTracking = _interopRequireDefault(require("crm_internal/utils/hubspotTracking"));

var _TrackingPixelUtils = _interopRequireDefault(require("tracking-pixels/TrackingPixelUtils"));

var _GoogleTracking = _interopRequireDefault(require("tracking-pixels/GoogleTracking"));

var _TrackingEvents = _interopRequireDefault(require("crm_internal/config/TrackingEvents"));

var _generalStore = require("general-store");

var _OnboardingTour = _interopRequireDefault(require("onboarding-tours/components/OnboardingTour"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactImmutableProptypes = _interopRequireDefault(require("react-immutable-proptypes"));

var _TwilioClientStore = _interopRequireDefault(require("TwilioUI/flux/TwilioClientStore"));

var StatusGroups = _interopRequireWildcard(require("TwilioUI/js/utils/statusGroups"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

var _underscore = require("underscore");

var LocalSettings = _interopRequireWildcard(require("crm_data/settings/LocalSettings"));

var _SidebarLayoutPrimaryContact = _interopRequireWildcard(require("crm_ui/sidebar/layouts/SidebarLayoutPrimaryContact"));

var _SidebarLayoutPrimaryCompany = _interopRequireWildcard(require("crm_ui/sidebar/layouts/SidebarLayoutPrimaryCompany"));

var _SidebarLayoutPrimaryDeal = _interopRequireWildcard(require("crm_ui/sidebar/layouts/SidebarLayoutPrimaryDeal"));

var _SidebarLayoutPrimaryTicket = _interopRequireWildcard(require("crm_ui/sidebar/layouts/SidebarLayoutPrimaryTicket"));

var _IsUngatedStore = _interopRequireDefault(require("crm_data/gates/IsUngatedStore"));

var _LinkedInSalesNavigatorInMail = _interopRequireDefault(require("crm_ui/linkedin/LinkedInSalesNavigatorInMail"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _InteractionTypes = require("customer-data-communicator/schema/interactions/InteractionTypes");

var _ErrorBoundary = _interopRequireDefault(require("customer-data-objects-ui-components/ErrorBoundary"));

var _PlaybooksStore = _interopRequireDefault(require("crm_data/playbooks/stores/PlaybooksStore"));

var _PlaybookCardWrapper = _interopRequireDefault(require("crm_ui/profile/sidebar/playbooks/PlaybookCardWrapper"));

var _CalleeActions = require("crm_data/calls/CalleeActions");

var _eventLogger = require("customer-data-communicator/data/communicator/utils/eventLogger");

var _CommunicatorPageActions = require("customer-data-communicator/data/communicator/actions/CommunicatorPageActions");

var _PhoneNumberActions = require("TwilioUI/js/flux/actions/PhoneNumberActions");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Raven = _interopRequireDefault(require("Raven"));

var _SidebarError = _interopRequireDefault(require("customer-data-sidebar/SidebarError"));

var _CardsStore = _interopRequireDefault(require("crm_ui/sidebar/layouts/CardsStore"));

var _PropertyGroupsStore = _interopRequireDefault(require("crm_ui/property/PropertyGroupsStore"));

var _CardsAPIConstants = require("crm_ui/sidebar/layouts/CardsAPIConstants");

var _identity = _interopRequireDefault(require("transmute/identity"));

var _OptInsDependency = require("crm_data/optIns/OptInsDependency");

var _isSampleContact = function _isSampleContact(subject) {
  return (0, _SampleContactUtils.getIsSampleContact)((0, _ImmutableModel.getProperty)(subject, 'email'));
};

var _shouldAttemptActivation = function _shouldAttemptActivation(subject, objectType) {
  var objectsToActivateOnView = [_ObjectTypes.CONTACT];
  return Array.from(objectsToActivateOnView).includes(objectType) && !_isSampleContact(subject);
};

var _trackUserActivation = function _trackUserActivation(settings, subject, objectType) {
  if (_shouldAttemptActivation(subject, objectType)) {
    _loggers.CrmLogger.log('activate-viewed-contact-profile', {
      type: 'user activation ',
      legacyPortalHasActivated: settings.get(_PortalSettingsKeys.PORTAL_HAS_ACTIVATION)
    });

    (0, _hubspotTracking.default)(_TrackingEvents.default.HUBSPOT.CRM_ACTIVATED);

    _TrackingPixelUtils.default.trackUserActivation();

    _GoogleTracking.default.trackActivation();
  }
};

var _injectSampleTimelineEvents = function _injectSampleTimelineEvents(subjectId, subject) {
  var sampleContactEmail = (0, _ImmutableModel.getProperty)(subject, 'email');
  (0, _SampleTimelineEventUtils.default)(subjectId, sampleContactEmail);
};

var _trackSampleContactView = function _trackSampleContactView(objectType) {
  return _loggers.CrmLogger.logRecordInteraction(objectType, {
    action: 'view sample record'
  });
};

var Profile = (0, _createReactClass.default)({
  displayName: 'Profile',
  propTypes: {
    activeInteraction: _propTypes.default.string,
    callProvider: _propTypes.default.shape({
      widgets: _reactImmutableProptypes.default.list
    }),
    communicatorTriggerLocation: _propTypes.default.string,
    isCommunicatorFullScreen: _propTypes.default.bool,
    isCommunicatorMinimized: _propTypes.default.bool,
    isIframeFullScreen: _propTypes.default.bool,
    isLinkedInSalesNavigatorMinimized: _propTypes.default.bool,
    isLinkedInSalesNavigatorSelected: _propTypes.default.bool,
    objectType: _ProfileObjectTypesType.default.isRequired,
    query: _propTypes.default.shape({
      interaction: _propTypes.default.string,
      forceLegacy: _propTypes.default.string
    }).isRequired,
    isPlaybookMinimized: _propTypes.default.bool.isRequired,
    primaryCardsAPILayout: _propTypes.default.arrayOf(_propTypes.default.shape({
      cardId: _propTypes.default.string.isRequired,
      cardType: _propTypes.default.string.isRequired
    }).isRequired),
    propertyGroups: _propTypes.default.arrayOf(_propTypes.default.shape({
      label: _propTypes.default.string.isRequired
    }).isRequired),
    selectedPlaybookId: _propTypes.default.string,
    subjectId: _propTypes.default.string.isRequired,
    settings: _reactImmutableProptypes.default.map,
    subject: _SubjectType.default,
    twilioClient: _reactImmutableProptypes.default.map,
    hasCardsAPI: _propTypes.default.bool,
    hasPropertiesRedesign: _propTypes.default.bool
  },
  getInitialState: function getInitialState() {
    return {
      contactOnboardingChecked: false,
      activationChecked: false,
      interactionTypeShown: null
    };
  },
  componentDidMount: function componentDidMount() {
    this.updateTitle();
    this.trackPermissions();
    this.maybeUpdateBackground();

    if (window.location.search.indexOf('interaction') > -1) {
      (0, _CommunicatorActions.setCommunicatorTriggerLocation)({
        triggerLocation: _CommunicatorConstants.PAGE_LOAD,
        subjectIdContext: this.props.subjectId,
        objectTypeContext: this.props.objectType
      });
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    this.maybeRedirect();
    this.updateTitle();
    this.maybeDoActivation();
    this.maybeInjectSampleTimelineItems();
  },
  componentWillUnmount: function componentWillUnmount() {
    (0, _CommunicatorActions.setCommunicatorTriggerLocation)(null);
  },
  maybeUpdateBackground: function maybeUpdateBackground() {
    var backgroundImage = LocalSettings.getFrom(localStorage, 'backgroundImage') || '';

    if (LocalSettings.getFrom(localStorage, 'CRM:BackgroundImages') && backgroundImage !== '') {
      var el = document.querySelector('.LayoutFullPage.profile-3-column');
      el.style.backgroundImage = "url('" + backgroundImage + "')";
      el.style.backgroundSize = 'cover';
    }
  },
  trackPermissions: function trackPermissions() {
    var _this$props = this.props,
        objectType = _this$props.objectType,
        subject = _this$props.subject;

    if (!subject) {
      return;
    }

    if ((0, _SubjectPermissions.canView)(subject)) {
      return;
    }

    _loggers.CrmLogger.logRecordInteraction(objectType, {
      action: 'Viewed profile without permissions - USE THIS ONE'
    });
  },
  getDefaultInteraction: function getDefaultInteraction() {
    var _this$props2 = this.props,
        subject = _this$props2.subject,
        query = _this$props2.query;

    if (subject && _isSampleContact(subject) && !query.interaction) {
      return query.interaction && 'note';
    }

    return query.interaction;
  },
  hasCallWidget: function hasCallWidget() {
    var callProvider = this.props.callProvider;
    return Boolean(callProvider && callProvider.widgets && callProvider.widgets.size);
  },
  maybeRedirect: function maybeRedirect() {
    var _this$props3 = this.props,
        objectType = _this$props3.objectType,
        subject = _this$props3.subject,
        subjectId = _this$props3.subjectId;

    if (objectType === _ObjectTypes.CONTACT && subject && subject.has('canonical-vid') && String(subject.get('canonical-vid')) !== String(subjectId)) {
      (0, _underscore.defer)(function () {
        return _RouterContainer.default.getContainer().get().navigate("/contact/" + subject.get('canonical-vid') + "/", {
          trigger: true,
          replace: true
        });
      });
    }

    if (objectType === _ObjectTypes.TICKET && subject && (0, _ImmutableModel.getId)(subject) !== +subjectId) {
      (0, _underscore.defer)(function () {
        return _RouterContainer.default.getContainer().get().navigate("/ticket/" + (0, _ImmutableModel.getId)(subject) + "/", {
          trigger: true,
          replace: true
        });
      });
    }
  },
  maybeDoActivation: function maybeDoActivation() {
    var _this$props4 = this.props,
        subject = _this$props4.subject,
        objectType = _this$props4.objectType,
        settings = _this$props4.settings;
    var activationChecked = this.state.activationChecked;

    if (!settings || !subject || activationChecked) {
      return;
    }

    this.setState({
      activationChecked: true
    });

    _trackUserActivation(settings, subject, objectType);
  },
  maybeInjectSampleTimelineItems: function maybeInjectSampleTimelineItems() {
    var _this$props5 = this.props,
        subject = _this$props5.subject,
        subjectId = _this$props5.subjectId,
        objectType = _this$props5.objectType,
        settings = _this$props5.settings;
    var contactOnboardingChecked = this.state.contactOnboardingChecked;

    if (!settings || !subject || contactOnboardingChecked) {
      return;
    }

    this.setState({
      contactOnboardingChecked: true
    });

    if (objectType === _ObjectTypes.CONTACT && _isSampleContact(subject)) {
      _injectSampleTimelineEvents(subjectId, subject);

      _trackSampleContactView(objectType);
    }
  },
  updateTitle: function updateTitle() {
    var subject = this.props.subject;

    if (subject) {
      document.title = (0, _ImmutableModel.toString)(subject);
    }
  },
  handleCardCommunicatorClick: function handleCardCommunicatorClick(interactionType, previewObjectType, previewSubjectId, objectType, subjectId, propertyName) {
    if (interactionType === _InteractionTypes.CALL) {
      (0, _CalleeActions.setCallee)(subjectId, subjectId, objectType);
      (0, _PhoneNumberActions.setSelectedPhoneNumberProperty)(subjectId, propertyName);
    }

    this.setState({
      communicatorSubjectId: subjectId,
      communicatorObjectType: objectType
    });

    _loggers.CrmLogger.logRecordInteraction(objectType, {
      action: 'opened floating communicator',
      subAction: 'clicked from right sidebar',
      type: interactionType
    });

    _loggers.CommunicatorLogger.log('communicatorInteraction', {
      action: 'open communicator',
      activity: interactionType,
      channel: interactionType === 'call' ? 'outbound call' : interactionType,
      source: 'profile'
    });

    (0, _CommunicatorActions.setCommunicatorTriggerLocation)({
      triggerLocation: _CommunicatorConstants.RIGHT_SIDEBAR,
      subjectIdContext: previewSubjectId || this.props.subjectId,
      objectTypeContext: previewObjectType || this.props.objectType
    });
    (0, _CommunicatorActions.showCommunicator)(interactionType);
    (0, _PlaybooksActions.conditionallyMinimizePlaybook)();
    (0, _eventLogger.logPageAction)({
      key: _CommunicatorPageActions.PageActions.COMMUNICATOR_TRIGGER_LOCATION,
      tags: {
        location: _CommunicatorConstants.RIGHT_SIDEBAR
      }
    });
  },
  handleCloseCommunicator: function handleCloseCommunicator() {
    this.removeInteractionQueryParams();
    this.setState({
      communicatorSubjectId: undefined,
      communicatorObjectType: undefined
    });
  },
  removeInteractionQueryParams: function removeInteractionQueryParams() {
    var query = this.props.query;

    var _links$getQueryParams = _links.default.getQueryParams(),
        currentQueryParams = _links$getQueryParams.currentQueryParams;

    var params = Object.assign(query, {
      interaction: null
    }, currentQueryParams);

    _links.default.setQueryParam({
      queryString: _links.default.toQueryString(params),
      navigationOptions: {
        trigger: false,
        replace: true
      }
    });
  },
  useCallingExtensionsForCall: function useCallingExtensionsForCall() {
    var activeInteraction = this.props.activeInteraction || this.getDefaultInteraction();

    if (activeInteraction !== _InteractionTypes.CALL) {
      return false;
    } // Has some calling extension widget


    var callProvider = this.props.callProvider;
    return callProvider && callProvider.widgets && callProvider.widgets.size;
  },
  chooseSidebarPrimaryLayoutConfig: function chooseSidebarPrimaryLayoutConfig() {
    var objectType = this.props.objectType;

    switch (objectType) {
      case _ObjectTypes.CONTACT:
        return _SidebarLayoutPrimaryContact.default;

      case _ObjectTypes.COMPANY:
        return _SidebarLayoutPrimaryCompany.default;

      case _ObjectTypes.DEAL:
        return _SidebarLayoutPrimaryDeal.default;

      case _ObjectTypes.TICKET:
        return _SidebarLayoutPrimaryTicket.default;

      default:
        _Raven.default.captureMessage("[Profile] Invalid object type " + objectType, {
          level: 'info'
        }); // this is the most basic "config" object that the sidebar will accept,
        // rendering an error to indicate something went wrong.


        return [{
          Content: _SidebarError.default
        }];
    }
  },
  chooseSidebarLayoutConfig: function chooseSidebarLayoutConfig() {
    switch (this.props.objectType) {
      case _ObjectTypes.COMPANY:
        return _SidebarLayoutCompany.default;

      case _ObjectTypes.CONTACT:
        return _SidebarLayoutContact.default;

      case _ObjectTypes.DEAL:
        return _SidebarLayoutDeal.default;

      case _ObjectTypes.TICKET:
      default:
        return _SidebarLayoutTicket.default;
    }
  },
  getMappings: function getMappings(objectType) {
    switch (objectType) {
      case _ObjectTypes.COMPANY:
        return _SidebarLayoutPrimaryCompany.CardsMapping;

      case _ObjectTypes.CONTACT:
        return _SidebarLayoutPrimaryContact.CardsMapping;

      case _ObjectTypes.DEAL:
        return _SidebarLayoutPrimaryDeal.CardsMapping;

      case _ObjectTypes.TICKET:
        return _SidebarLayoutPrimaryTicket.CardsMapping;

      default:
        _Raven.default.captureMessage("[Profile] Invalid object type " + objectType, {
          level: 'info'
        });

        return undefined;
    }
  },
  chooseCardsAPIPrimaryLayout: function chooseCardsAPIPrimaryLayout() {
    var _this$props6 = this.props,
        primaryCardsAPILayout = _this$props6.primaryCardsAPILayout,
        objectType = _this$props6.objectType;
    if (!primaryCardsAPILayout) return [];
    var cardMappings = this.getMappings(objectType);

    if (!cardMappings) {
      // this is the most basic "config" object that the sidebar will accept,
      // rendering an error to indicate something went wrong.
      return [{
        Content: _SidebarError.default
      }];
    }

    return primaryCardsAPILayout.map(function (cardResponse) {
      var cardId = cardResponse.cardId;
      var cardType = cardId === _CardsAPIConstants.GLOBAL_PROPERTIES_CARD_ID ? _CardsAPIConstants.GLOBAL_PROPERTIES_CARD_TYPE : cardResponse.cardType;

      if (cardType === _CardsAPIConstants.PROPERTIES_CARD_TYPE) {
        return undefined;
      }

      var cardConfig = cardMappings[cardType];

      if (!cardConfig) {
        _Raven.default.captureMessage("[Profile] Unsupported card type " + cardType, {
          level: 'info'
        });

        return undefined;
      }

      return (0, _extends2.default)({}, cardConfig, {
        key: cardType + ":" + cardId
      });
    }).concat(this.getPropertyExperimentCards()).filter(function (config) {
      return (0, _identity.default)(config);
    });
  },
  getPropertyExperimentCards: function getPropertyExperimentCards() {
    var _this$props7 = this.props,
        hasPropertiesRedesign = _this$props7.hasPropertiesRedesign,
        propertyGroups = _this$props7.propertyGroups,
        objectType = _this$props7.objectType;

    if (!hasPropertiesRedesign || !propertyGroups) {
      return [];
    }

    var cardMappings = this.getMappings(objectType);
    return propertyGroups.map(function (propertyGroup) {
      var cardId = propertyGroup.cardId;
      var cardType = propertyGroup.cardType;

      if (!cardId) {
        return undefined;
      }

      var cardConfig = cardMappings[cardType];

      if (!cardConfig) {
        _Raven.default.captureMessage("[Profile] Unsupported card type " + cardType, {
          level: 'info'
        });

        return undefined;
      }

      return (0, _extends2.default)({}, cardConfig, {
        key: cardType + ":" + cardId
      });
    }).filter(function (config) {
      return (0, _identity.default)(config);
    });
  },
  getCardsAPIData: function getCardsAPIData() {
    var _this$props8 = this.props,
        hasPropertiesRedesign = _this$props8.hasPropertiesRedesign,
        propertyGroups = _this$props8.propertyGroups;
    if (!hasPropertiesRedesign || !propertyGroups) return {};
    return propertyGroups.reduce(function (cardsData, propertyGroup) {
      var cardId = propertyGroup.cardId;
      var cardType = propertyGroup.cardType;

      if (!cardId && !cardType) {
        return cardsData;
      }

      cardsData[cardType + ":" + cardId] = propertyGroup;
      return cardsData;
    }, {});
  },
  renderQueuePlaylistTopbar: function renderQueuePlaylistTopbar() {
    var _this$props9 = this.props,
        subjectId = _this$props9.subjectId,
        objectType = _this$props9.objectType;
    var callStatus = this.props.twilioClient.get('status');

    if (StatusGroups.isCallStarted(callStatus) || !(0, _InteractionValidators.userCanViewQueues)()) {
      return null;
    }

    return _react.default.createElement(_QueueTopbarContainerAsync.default, {
      key: "QueueTopbarContainer",
      objectType: objectType,
      subjectId: subjectId
    });
  },
  renderCallTopbarWrapper: function renderCallTopbarWrapper() {
    var _this$props10 = this.props,
        subjectId = _this$props10.subjectId,
        objectType = _this$props10.objectType;

    if (this.hasCallWidget()) {
      return null;
    }

    return _react.default.createElement(_CallTopbarWrapperAsync.default, {
      key: "calltopBarWrapper",
      objectId: subjectId,
      objectType: objectType
    });
  },
  renderInteractionOverlay: function renderInteractionOverlay() {
    var _this$props11 = this.props,
        objectType = _this$props11.objectType,
        subjectId = _this$props11.subjectId,
        query = _this$props11.query,
        communicatorTriggerLocation = _this$props11.communicatorTriggerLocation,
        isCommunicatorFullScreen = _this$props11.isCommunicatorFullScreen,
        isCommunicatorMinimized = _this$props11.isCommunicatorMinimized;
    var activeInteraction = this.props.activeInteraction;
    var _this$state = this.state,
        communicatorObjectType = _this$state.communicatorObjectType,
        communicatorSubjectId = _this$state.communicatorSubjectId;
    var originatesFromRightSidebar = communicatorTriggerLocation === _CommunicatorConstants.RIGHT_SIDEBAR;
    var targetSubjectId = originatesFromRightSidebar && communicatorSubjectId ? communicatorSubjectId : subjectId;
    var targetObjectType = originatesFromRightSidebar && communicatorObjectType ? communicatorObjectType : objectType;

    if (!activeInteraction) {
      activeInteraction = this.getDefaultInteraction();
    }

    if (!activeInteraction) {
      return null;
    }

    if (this.useCallingExtensionsForCall() || activeInteraction === _InteractionTypes.CALL && (0, LoadingStatus.isLoading)(this.props.callProvider)) {
      // Do not render call communicator if the callProvider API hasn't responded
      return null;
    }

    var className = (0, _classnames.default)('onboarding-peek-communicator communicator-overlay', {
      fullscreen: this.props.isIframeFullScreen
    });
    return _react.default.createElement("div", {
      className: className,
      key: "interaction-overlay"
    }, _react.default.createElement(_ProfileCommunicatorContainer.default, {
      defaultInteraction: activeInteraction,
      handleCloseCommunicator: this.handleCloseCommunicator,
      isFullScreen: isCommunicatorFullScreen,
      isMinimized: isCommunicatorMinimized,
      objectType: targetObjectType,
      ownerId: _CurrentOwnerContainer.default.get(),
      teamId: _CurrentTeamsContainer.default.getMyTeam(),
      query: query,
      subjectId: targetSubjectId
    }));
  },
  renderLinkedInNavigator: function renderLinkedInNavigator() {
    var _this$props12 = this.props,
        objectType = _this$props12.objectType,
        subject = _this$props12.subject,
        subjectId = _this$props12.subjectId,
        isLinkedInSalesNavigatorSelected = _this$props12.isLinkedInSalesNavigatorSelected,
        isLinkedInSalesNavigatorMinimized = _this$props12.isLinkedInSalesNavigatorMinimized;

    if (!isLinkedInSalesNavigatorSelected) {
      return null;
    }

    return _react.default.createElement(_LinkedInSalesNavigatorInMail.default, {
      objectType: objectType,
      subject: subject,
      subjectId: subjectId,
      isMinimized: isLinkedInSalesNavigatorMinimized
    });
  },
  renderPlaybook: function renderPlaybook() {
    var _this$props13 = this.props,
        isPlaybookMinimized = _this$props13.isPlaybookMinimized,
        objectType = _this$props13.objectType,
        selectedPlaybookId = _this$props13.selectedPlaybookId,
        subject = _this$props13.subject,
        subjectId = _this$props13.subjectId;

    if (!selectedPlaybookId) {
      return null;
    }

    return _react.default.createElement(_PlaybookCardWrapper.default, {
      key: "playbook-overlay",
      objectType: objectType,
      subjectId: subjectId,
      subject: subject,
      selectedPlaybookId: selectedPlaybookId,
      isMinimized: isPlaybookMinimized
    });
  },
  renderError: function renderError() {
    var _this$props14 = this.props,
        objectType = _this$props14.objectType,
        subjectId = _this$props14.subjectId;
    return _react.default.createElement(_UIErrorMessage.default, {
      key: objectType + subjectId,
      type: "notFound",
      "data-error": 404,
      className: "error-message"
    });
  },
  renderTopFullWidth: function renderTopFullWidth() {
    return _react.default.createElement("div", null, this.renderQueuePlaylistTopbar(), this.renderCallTopbarWrapper());
  },
  renderCallWidgetHost: function renderCallWidgetHost() {
    var _this$props15 = this.props,
        callProvider = _this$props15.callProvider,
        objectType = _this$props15.objectType,
        subjectId = _this$props15.subjectId,
        query = _this$props15.query,
        activeInteraction = _this$props15.activeInteraction,
        communicatorTriggerLocation = _this$props15.communicatorTriggerLocation;
    var _this$state2 = this.state,
        communicatorSubjectId = _this$state2.communicatorSubjectId,
        communicatorObjectType = _this$state2.communicatorObjectType;

    if (!callProvider || !callProvider.widgets.size) {
      return null;
    }

    var targetSubjectId = subjectId;
    var targetObjectType = objectType;

    if (communicatorTriggerLocation === _CommunicatorConstants.RIGHT_SIDEBAR && communicatorSubjectId && communicatorObjectType) {
      targetSubjectId = communicatorSubjectId;
      targetObjectType = communicatorObjectType;
    }

    return _react.default.createElement(_ErrorBoundary.default, {
      boundaryName: "callCommunicatorWrapper"
    }, _react.default.createElement(_CallCommunicatorWrapperAsync.default, {
      activeInteraction: activeInteraction || this.getDefaultInteraction(),
      key: "CallCommunicatorWrapper",
      objectType: targetObjectType,
      ownerId: _CurrentOwnerContainer.default.get(),
      subjectId: targetSubjectId,
      query: query
    }));
  },
  render: function render() {
    var _this$props16 = this.props,
        subject = _this$props16.subject,
        objectType = _this$props16.objectType,
        subjectId = _this$props16.subjectId,
        query = _this$props16.query,
        hasCardsAPI = _this$props16.hasCardsAPI;
    var taskId = query.taskId;

    if (LoadingStatus.isEmpty(subject)) {
      return this.renderError();
    }

    if (objectType === _ObjectTypes.CONTACT && subject && !subject.get('is-contact')) {
      return this.renderError();
    }

    var key = objectType + subjectId + (taskId || '') + (query && query._t || '');
    var sidebarLayoutPrimary = hasCardsAPI ? this.chooseCardsAPIPrimaryLayout() : this.chooseSidebarPrimaryLayoutConfig();
    var sidebarDataPrimary = hasCardsAPI ? this.getCardsAPIData() : {};
    var sidebarLayoutSecondary = this.chooseSidebarLayoutConfig();
    return _react.default.createElement(_ProfileThreeColumn.default, {
      key: key,
      objectType: objectType,
      subjectId: subjectId,
      topFullWidth: this.renderTopFullWidth(),
      OverlaysRightSidebar: [this.renderCallWidgetHost(true), this.renderInteractionOverlay(), this.renderLinkedInNavigator(), this.renderPlaybook()],
      subject: subject,
      overlays: [_react.default.createElement(_OnboardingTour.default, {
        key: "onboarding-tour"
      })],
      onCommunicatorClick: this.handleCardCommunicatorClick,
      activeInteraction: this.props.activeInteraction,
      isCommunicatorFullScreen: this.props.isCommunicatorFullScreen,
      sidebarDataPrimary: sidebarDataPrimary,
      sidebarLayoutPrimary: sidebarLayoutPrimary,
      sidebarLayoutSecondary: sidebarLayoutSecondary
    }, _react.default.createElement(_ProfileTimelineTabsContainer.default, {
      key: "timeline-tabs-container-" + objectType + "-" + subjectId,
      objectType: objectType,
      subjectId: subjectId,
      hasCommunicatePermissions: (0, _SubjectPermissions.canCommunicate)(subject)
    }));
  }
});

var _default = (0, _generalStore.connect)({
  subject: _SubjectDependency.default,
  settings: _SettingsStore.default,
  callProvider: _CallProviderDependency.default,
  twilioClient: _TwilioClientStore.default,
  activeInteraction: {
    stores: [_CommunicatorStore.default],
    deref: function deref() {
      return _CommunicatorStore.default.get('interaction');
    }
  },
  communicatorTriggerLocation: {
    stores: [_CommunicatorStore.default],
    deref: function deref() {
      return _CommunicatorStore.default.get('triggerLocation');
    }
  },
  isCommunicatorMinimized: {
    stores: [_CommunicatorStore.default],
    deref: function deref() {
      return _CommunicatorStore.default.get('isMinimized');
    }
  },
  isCommunicatorFullScreen: {
    stores: [_CommunicatorStore.default],
    deref: function deref() {
      return _CommunicatorStore.default.get('isFullScreen');
    }
  },
  isIframeFullScreen: {
    stores: [_CommunicatorStore.default],
    deref: function deref() {
      return _CommunicatorStore.default.get('iframeDimensions') === 'fullscreen';
    }
  },
  isLinkedInSalesNavigatorSelected: {
    stores: [_LinkedInNavigatorStore.default],
    deref: function deref() {
      return _LinkedInNavigatorStore.default.get('isSelected');
    }
  },
  isLinkedInSalesNavigatorMinimized: {
    stores: [_LinkedInNavigatorStore.default],
    deref: function deref() {
      return _LinkedInNavigatorStore.default.get('isMinimized');
    }
  },
  selectedPlaybookId: {
    stores: [_PlaybooksStore.default],
    deref: function deref() {
      return _PlaybooksStore.default.get('selectedPlaybookId');
    }
  },
  isPlaybookMinimized: {
    stores: [_PlaybooksStore.default],
    deref: function deref() {
      return _PlaybooksStore.default.get('isMinimized');
    }
  },
  hasCardsAPI: {
    stores: [_IsUngatedStore.default],
    deref: function deref() {
      return _IsUngatedStore.default.get('CRM:CardsAPI');
    }
  },
  hasPropertiesRedesign: (0, _OptInsDependency.isOptedInDependency)('property-redesign'),
  primaryCardsAPILayout: {
    stores: [_CardsStore.default],
    deref: function deref(_ref) {
      var objectType = _ref.objectType;

      var layout = _CardsStore.default.get(objectType);

      return layout && layout.get(_CardsAPIConstants.LEFT_SIDEBAR).toJS();
    }
  },
  propertyGroups: {
    stores: [_PropertyGroupsStore.default],
    deref: function deref(_ref2) {
      var objectType = _ref2.objectType,
          subjectId = _ref2.subjectId;

      var propertyGroups = _PropertyGroupsStore.default.get({
        objectType: objectType,
        subjectId: subjectId
      });

      return propertyGroups && propertyGroups.get('propertyCards').toJS();
    }
  }
})(Profile);

exports.default = _default;
module.exports = exports.default;